import React from 'react';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import {
  arrayOf, bool, func, oneOf, shape, string, number
} from 'prop-types';
import { NUMBER_OF_DROPDOWN_ITEMS_FOR_VIEW_MORE,
  WIDTH_OF_TOOLTIP } from '../../statics';
import { MoreOptions } from '../more-options/more-options';
import { SuperSkuAttributeValue } from '../super-sku-attribute-value/super-sku-attribute-value';
import './mini-swatch-tooltip.scss';

export const MiniSwatchTooltip = (props) => {
  const {
    attributeName,
    attributeType,
    attributeValues,
    canonicalUrl,
    channel,
    handleAttributeValueClick,
    handleAttributeValueHover,
    handleResetHover,
    isOverflowSection,
    isTooltipsEnabled,
    selectedAttribute
  } = props;

  const miniSwatchToolTipContent = (
    <div className="super-sku__inline-swatch__mini-swatch__tooltip-wrapper">
      <div className="super-sku__inline-swatch__mini-swatch__swatch-wrapper">
        {attributeValues.map((attributeValue) => {
          const { value, swatchGuid } = attributeValue || {};
          return (
            <SuperSkuAttributeValue
              attributeType={attributeType}
              channel={channel}
              displayInToolTip
              isAvailable
              isOverflowSection={isOverflowSection}
              isSelected={selectedAttribute === value}
              isTooltipsEnabled={isTooltipsEnabled}
              key={`${attributeName}-${value}`}
              miniSwatch
              onClick={(event) => handleAttributeValueClick(
                event,
                attributeName,
                value
              )}
              onMouseEnter={((event) => handleAttributeValueHover(event,
                attributeName,
                value,
                isTooltipsEnabled,
                true
              ))}
              onMouseLeave={handleResetHover}
              swatchGuid={swatchGuid}
              value={value}
            />
          );
        })}
      </div>
      {attributeValues.length > NUMBER_OF_DROPDOWN_ITEMS_FOR_VIEW_MORE
      && canonicalUrl
      && <MoreOptions canonicalUrl={canonicalUrl} displayInTooltip />}
    </div>
  );
  return (
    <Tooltip
      channel="desktop"
      className="thd-react-tooltip__content--no-padding"
      content={<div>{miniSwatchToolTipContent}</div>}
      interactive
      maxWidth={WIDTH_OF_TOOLTIP}
      placement="bottom"
      trigger="click"
    >
      <div className="super-sku__mini-swatches__caret" data-testid="mini-swatches" />
    </Tooltip>
  );
};

MiniSwatchTooltip.displayName = 'MiniSwatchTooltip';

MiniSwatchTooltip.propTypes = {
  attributeName: string.isRequired,
  attributeType: string.isRequired,
  attributeValues: arrayOf(shape({})).isRequired,
  canonicalUrl: string.isRequired,
  channel: oneOf(['desktop', 'mobile']).isRequired,
  handleAttributeValueClick: func.isRequired,
  handleAttributeValueHover: func.isRequired,
  handleResetHover: func.isRequired,
  isOverflowSection: bool.isRequired,
  isTooltipsEnabled: bool.isRequired,
  selectedAttribute: string.isRequired
};

export const MiniSwatchTooltipPerformance = (props) => {
  const {
    channel,
    handleAttributeValueClick,
    handleAttributeValueHover,
    handleResetHover,
    onTooltipOpen,
    swatches,
    totalNumberOfOptions,
    canonicalUrl
  } = props;

  const miniSwatchToolTipContent = (
    <div className="super-sku__inline-swatch__mini-swatch__tooltip-wrapper">
      <div className="super-sku__inline-swatch__mini-swatch__swatch-wrapper">
        {(swatches || []).map((swatch, index) => {
          const {
            isSelected,
            itemId: swatchItemId,
            label,
            swatchImgUrl
          } = swatch || {};
          return (
            <SuperSkuAttributeValue
              attributeType="swatch"
              channel={channel}
              isAvailable
              displayInToolTip
              isSelected={isSelected}
              key={`mini-${index}`}
              miniSwatch
              onClick={(event) => handleAttributeValueClick(event, swatchItemId)}
              onMouseEnter={((event) => handleAttributeValueHover(event, swatchItemId))}
              onMouseLeave={handleResetHover}
              swatchGuid={swatchImgUrl}
              value={label}
            />
          );
        })}
      </div>
      {totalNumberOfOptions > NUMBER_OF_DROPDOWN_ITEMS_FOR_VIEW_MORE
        && canonicalUrl
        && <MoreOptions canonicalUrl={canonicalUrl} displayInTooltip />}
    </div>
  );
  return (
    <Tooltip
      channel="desktop"
      className="thd-react-tooltip__content--no-padding"
      content={<div>{miniSwatchToolTipContent}</div>}
      interactive
      maxWidth={WIDTH_OF_TOOLTIP}
      placement="bottom"
      trigger="click"
      onShow={() => onTooltipOpen()}
    >
      <div className="super-sku__mini-swatches__caret" data-testid="mini-swatches" />
    </Tooltip>
  );
};

MiniSwatchTooltipPerformance.displayName = 'MiniSwatchTooltip';

MiniSwatchTooltipPerformance.propTypes = {
  canonicalUrl: string.isRequired,
  channel: oneOf(['desktop', 'mobile']).isRequired,
  handleAttributeValueClick: func.isRequired,
  handleAttributeValueHover: func.isRequired,
  handleResetHover: func.isRequired,
  onTooltipOpen: func.isRequired,
  swatches: arrayOf(shape({})).isRequired,
  totalNumberOfOptions: number,
};

MiniSwatchTooltipPerformance.defaultProps = {
  totalNumberOfOptions: 0
};
